jQuery(document).ready(function(){
    setTimeout(function(){
        if(typeof window.UploadKit.resetUploaders === 'function') {
        window.UploadKit.config.uploaders[2].required = false;
        window.UploadKit.resetUploaders();
        }
    }, 500);

    jQuery(document).on("click", "div[data-block-type='variant-picker'] .block-swatch", function(){
        setTimeout(function(){
        const urlParams = new URLSearchParams(window.location.search);
        const variant_id = urlParams.get('variant');
        jQuery(".v-stack .price-list.price-list--product .custom-sale-price-price.h4.text-subdued").attr("data-variant-id", variant_id);
        jQuery(".v-stack .price-list .custom-sale-price-.h6.text-subdued").attr("data-variant-id", variant_id);

        jQuery(".v-stack .price-list.price-list--product .custom-compare-price-price").attr("data-variant-id", variant_id);
        jQuery(".v-stack .price-list .custom-compare-price-").attr("data-variant-id", variant_id);
        }, 50);
    });
    if(jQuery("buy-buttons[template='custom-order-help-choose']").length > 0) {
        jQuery(".product-sticky-bar button[type='submit']").on("click", function(e){
        e.preventDefault();
        jQuery("[data-block-type='@app'] + [data-block-type='buy-buttons'] .buy-buttons > button[type='submit']").trigger("click");
        });
    }
})